import {DomainObject} from 'shared/store';
import { action, observable, computed, makeObservable } from 'mobx';

class Session extends DomainObject {
  id;
  email;
  password;
  currentUserId;
  cellphone;
  mfaRequired;
  mfaType;
  mfaToken;
  recoveryCode;
  rememberDevice = false;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      email: observable,
      password: observable,
      currentUserId: observable,
      cellphone: observable,
      mfaRequired: observable,
      mfaType: observable,
      mfaToken: observable,
      recoveryCode: observable,
      rememberDevice: observable,
      clearFields: action,
      isSms: computed,
      isAuthenticator: computed
    });

    this.merge(other);
  }

  clearFields() {
    this.merge({
      password: null,
      mfaRequired: false,
      mfaToken: null,
      mfaType: null,
      cellphone: null,
      recoveryCode: null,
      rememberDevice: false
    });
  }

  get isSms() {
    return this.mfaType === 'sms';
  }

  get isAuthenticator() {
    return this.mfaType === 'authenticator';
  }
}

export default Session;
